export default class NotificacoesPendentes {
  public cod_notificacao: number = 0
  public idusuario: number = 0
  public chave_publica: string = ''
  public chave_privada: string = ''
  public endereco_envio: string = ''
  public cod_lote: number = 0
  public titulo: string = ''
  public detalhe: string = ''
  public processo: string = ''
  public objeto: string = ''
  public url_atena: string = ''
  public data_ultima_notif: string = ''
}
